import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";
import AdminPageShell from "@/admin/AdminPageShell";
import { CheckCircle2 } from "lucide-react";

const AdminApprovals = () => {
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => adminApi.get("/approvals").then((res) => setDrafts(res.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    await adminApi.post(`/approvals/${id}/approve`);
    load();
  };

  return (
    <AdminPageShell title="Approvals" description="Draft blog posts awaiting sign-off before they go live." testId="admin-approvals-page">
      {loading ? <p className="text-small">Loading…</p> : (
        <div className="space-y-3">
          {drafts.map((d) => (
            <div key={d.id} className="neu-surface p-5 flex items-center justify-between gap-4 flex-wrap" data-testid={`admin-approval-row-${d.id}`}>
              <div>
                <p className="text-body font-semibold" style={{ color: "var(--gg-ivory)" }}>{d.title}</p>
                <p className="text-small">{d.category} &middot; by {d.author}</p>
              </div>
              <button onClick={() => approve(d.id)} className="btn-solid-pearl btn-pill-sm" data-testid={`admin-approval-approve-${d.id}`}><CheckCircle2 size={14} /> Approve & Publish</button>
            </div>
          ))}
          {drafts.length === 0 && <p className="text-small">No drafts awaiting approval.</p>}
        </div>
      )}
    </AdminPageShell>
  );
};

export default AdminApprovals;
